import { render } from "./NotFound.vue?vue&type=template&id=49481a22&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=49481a22&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49481a22"]])

export default __exports__